import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  InsertChildImpactRatingsMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertChildImpactRatingsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertChildImpactRatingsInput {
  Ratings: { ImpactId: string; Rating: number }[];
  TestDate: string;
  RatedItemId: string;
  AssessmentId?: InputMaybe<string>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
  CompletedBy?: InputMaybe<string>;
  Likelihood?: InputMaybe<number>;
}

export const useInsertChildImpactRatings = createMutationHook({
  name: 'insertChildImpactRatings',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.impactRating.insertBatch.mutationOptions({ onSuccess }),
  mapInput: (input: InsertChildImpactRatingsInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.impactRating.impactRatings.queryKey(),
    trpc.frontend.impactRating.impactRatingById.queryKey(),
    trpc.frontend.impactRating.impactRatingsByImpactId.queryKey(),
    trpc.frontend.impactRating.impactRatingsByRatedItemId.queryKey(),
    trpc.frontend.impactRating.impactRatingsWithAppetites.queryKey(),
    trpc.frontend.impactRating.impactRatingCount.queryKey(),
    // Assessment views may show rating data
    trpc.frontend.assessment.register.queryKey(),
    trpc.frontend.assessment.resultsRegister.queryKey(),
  ],
  mapResponse: (result: {
    Ids: string[];
  }): InsertChildImpactRatingsMutation => ({
    insertChildImpactRating: {
      __typename: 'insertChildImpactRatingOutput',
      Ids: result.Ids,
    },
  }),
  graphqlDocument: InsertChildImpactRatingsDocument,
  graphqlVariables: (input: InsertChildImpactRatingsInput) => ({ ...input }),
  evictFields: ['impact_rating', 'assessment'],
});
